/* SB Diamonds storefront navigation. Uses native collection/tag URLs so filters
   and sorting apply across the entire catalog. Recognized legacy preview links
   redirect to real collections. Customer inquiry text is never logged or stored. */
(() => {
  'use strict';
  const params = new URLSearchParams(window.location.search);
  const category = document.querySelector('#category-filter');
  const stone = document.querySelector('#stone-filter');
  const sort = document.querySelector('#sort-filter');
  const categories = ['all', 'necklaces', 'pendants', 'bracelets', 'rings', 'earrings', 'watches'];
  // Build only known same-origin routes; query text cannot inject markup or URLs.
  const collectionUrl = (categoryValue, stoneValue, sortValue) => {
    const handle = categories.includes(categoryValue) ? categoryValue : 'all';
    const tag = handle === 'watches' ? '' : { natural: '/natural-diamond', lab: '/lab-diamond' }[stoneValue] || '';
    const url = new URL('/collections/' + handle + tag, window.location.origin);
    if (sortValue) url.searchParams.set('sort_by', sortValue);
    if (params.has('preview_theme_id')) url.searchParams.set('preview_theme_id', params.get('preview_theme_id'));
    return url;
  };
  if (params.get('view') === 'catalog') {
    const requested = params.get('category');
    const legacyCategory = requested === 'chains' ? 'necklaces' : requested;
    const legacyStone = requested === 'lab-diamonds' ? 'lab' : params.get('stone');
    window.location.replace(collectionUrl(legacyCategory, legacyStone, ''));
    return;
  }
  // Old information-view links retain product enquiry context and land on a
  // native page. Only this fixed list can supply a destination.
  const pageViews = ['about', 'contact', 'custom', 'faq', 'shipping', 'returns', 'bridal', 'financing'];
  const view = params.get('view');
  if (pageViews.includes(view)) {
    const destination = new URL('/pages/' + view, window.location.origin);
    if (params.has('piece')) destination.searchParams.set('piece', params.get('piece').slice(0, 120));
    if (params.has('preview_theme_id')) destination.searchParams.set('preview_theme_id', params.get('preview_theme_id'));
    window.location.replace(destination);
    return;
  }
  // Dedicated origin collections stay compatible with saved links, but their
  // preferred category/tag route is shared with the menu and homepage.
  const preferredPath = document.querySelector('[data-canonical-path]')?.dataset.canonicalPath;
  if (preferredPath && preferredPath !== window.location.pathname) {
    const destination = new URL(preferredPath, window.location.origin);
    ['sort_by', 'page', 'preview_theme_id'].forEach((key) => {
      if (params.has(key)) destination.searchParams.set(key, params.get(key));
    });
    window.location.replace(destination);
    return;
  }
  // Sorting preserves the current collection and tag boundary. Pagination resets
  // because the product order changed; filter changes use the selected category.
  if (category && stone && sort) {
    [category, stone].forEach((field) => field.addEventListener('change', () => {
      window.location.assign(collectionUrl(category.value, stone.value, sort.value));
    }));
    sort.addEventListener('change', () => {
      const destination = new URL(window.location.href);
      destination.searchParams.set('sort_by', sort.value);
      destination.searchParams.delete('page');
      window.location.assign(destination);
    });
  }
  // Keep one category and one material panel open, and dismiss with Escape or
  // an outside click. Native details still work when scripts are unavailable.
  const menus = [...document.querySelectorAll('.nav-tree, .nav-branch')];
  menus.forEach((menu) => menu.addEventListener('toggle', () => {
    if (!menu.open) return;
    menus.forEach((other) => {
      if (other !== menu && other.parentElement === menu.parentElement) other.open = false;
    });
  }));
  document.addEventListener('click', (event) => {
    menus.forEach((menu) => { if (!menu.contains(event.target)) menu.open = false; });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const current = document.activeElement?.closest('.nav-branch, .nav-tree');
    if (current) { current.open = false; current.querySelector('summary').focus(); }
    else menus.forEach((menu) => { menu.open = false; });
  });
  const message = document.querySelector('#message');
  if (message && params.get('piece')) {
    message.value = 'I am interested in a piece inspired by the ' + params.get('piece').slice(0, 120) + '.\n\nMy preferred details: ';
  }
})();
